import { render, staticRenderFns } from "./TissueBank.vue?vue&type=template&id=23407484&scoped=true&"
import script from "./TissueBank.vue?vue&type=script&lang=js&"
export * from "./TissueBank.vue?vue&type=script&lang=js&"
import style0 from "./TissueBank.vue?vue&type=style&index=0&id=23407484&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23407484",
  null
  
)

export default component.exports